import React from 'react';

function Home() {
  return(
    <div className="home">
      <h1>Welcome</h1>
      <p>Page is still in progress so for now I invite you to play memory. Have fun!</p>
    </div>
  );
}

export default Home;
